<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="moduleForm">
		<!-- NOME * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						formControlName="Name"
						autocomplete="module-name"
						placeholder="{{ 'NAME' | translate }}"
						maxlength="48"
					/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
	   </div>
	   <!-- FIRMWARE * -->
	   <div class="grid">
			<div class="col-12 text-sm flex justify-content-start align-items-center flex-wrap">
				<div>{{'FWVersion' | translate }}: {{(module.FWVersion) ? (module.FWVersion) : ('NO_TASK_INFO_AVAILABLE' | translate)}}</div>
			</div>
		</div>
	
	   <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
	   </div>
	</form>
</div>
	